import styled from 'styled-components';
import TimesRow from './TimesRow';

export default styled(TimesRow)`
  width: 100%;
  background: var(--white);
  padding: 0.8rem 1.6rem;
  border-bottom: 1px solid var(--grey300);
  display: flex;
  align-items: center;

  .times-row {
    &__times-wrapper {
      flex: 1;
    }

    &__time-container {
      display: flex;
      flex: 1;
      align-items: center;
      & + & {
        margin-top: 0.4rem;
      }
    }

    &__pending-appointment {
      font-weight: bold;
      color: var(--accent900);
    }

    &__date {
      width: 70px;
    }

    &__time {
      font-weight: bold;
    }

    &__label {
      margin-left: 0.4rem;
    }
  }
`;
